import React, { useState, useEffect } from 'react';
import { Card, Nav, Form, Button, Badge, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { Package2Icon, UserIcon } from '../../static/icons/navicons.js';

import { useDispatch } from 'react-redux';
import { logout } from '../../redux/slice/auth/user-slice';
import logo from '../../static/images/app-logo.png';

const NavTag = ({ user }) => {
  const [isMobileView, setIsMobileView] = useState(false);

  // Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    // Function to check if the screen width is mobile-sized
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    // Initial check on component mount
    handleResize();

    // Event listener for resizing the window
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <div className="w-full flex-1 nav-tag">
      <header
        className="flex items-center justify-between gap-4 p-2 px-3 position-fixed top-0 start-0 w-100 z-50 "
        style={{ backgroundColor: 'black' }}
      >
        <div>
          <h4 className="m-0 d-flex align-items-center gap-2 font-semibold tracking-tighter text-light">
            {user && user.role !== 'customer' && (
              <span className="d-flex align-items-center gap-2 font-semibold text-primary">
                <img alt="Logo" src={logo} width={100} height={100} />
                <span
                  className="mr-3"
                  style={{ color: 'white', fontFamily: 'Lucida Handwriting' }}
                >
                  Falcon
                </span>
              </span>
            )}
            {!isMobileView && (
              <span
                className="blockquote-footer tracking-tighter animate-pulse text-light"
                style={{ marginBottom: '-16px' }}
              >
                Delivering Beyond Expectations
              </span>
            )}
          </h4>
        </div>
        <div>
          {/* Dropdown Menu */}
          <Dropdown>
            <Dropdown.Toggle
              as={CustomToggle}
              className="rounded-full border border-gray-200 w-8 h-8 dark:border-gray-800"
              size="sm"
              variant="light"
            >
              <Button
                className="rounded-full"
                size="icon"
                style={{ backgroundColor: 'transparent' }}
              >
                <UserIcon className="w-6 h-6" />
              </Button>
            </Dropdown.Toggle>
            <Dropdown.Menu className="shadow-sm py-1" size="xs">
              <Dropdown.Item
                as={Link}
                className="text-decoration-none"
                onClick={handleLogout}
                to="/login"
              >
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
            {!isMobileView && (
              <h6
                className="mr-3 ml-4"
                style={{ display: 'inline', color: 'white' }}
              >
                Hello! {user.name}
              </h6>
            )}
          </Dropdown>
        </div>
      </header>
    </div>
  );
};

// CustomToggle component to render the toggle without the arrow
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <Button
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    style={{ border: 'none', background: 'none', padding: 0 }}
  >
    {children}
  </Button>
));

CustomToggle.displayName = 'CustomToggle';

export default NavTag;
